export default __webpack_public_path__ + "static/media/PhoneIllustration.fe55635f.svg";